import React, { FC } from 'react';
import { useClsDirectionalityQuery, useClsFinancingTypesQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface FinancingTypes extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
  disabled?: boolean;
}

const FinancingTypes: FC<FinancingTypes> = ({ label, error, control, name, rules, disabled }) => {
  const { data } = useClsFinancingTypesQuery();
  let multiple = false;
  if (name == 'clsFinancingTypes') multiple = true;
  return (
    <Select
      label={label}
      data={(data && data.classifierValues) || []}
      control={control}
      error={error}
      name={name}
      multiple={multiple}
      rules={rules}
      disabled={disabled}
    />
  );
};

export default FinancingTypes;
